import { SelectOption } from './select-option';

export class SelectDefinition {
    uuid: string;
    identifier: string;
    options = new Array<SelectOption>();

    constructor(definition?: SelectDefinition) {
        if (definition != null) {

            this.uuid = definition.uuid;
            this.identifier = definition.identifier;

            if (definition.options != null) {
                for (const o of definition.options) {
                    this.options.push(new SelectOption(o));
                }
            }
        }
    }
}